<template>
  <Component
    :is="tag"
    class="rs-image"
    :class="imageClasses"
    :style="{
      height: height,
      width: width,
    }"
  >
    <img
      class="rs-image__image"
      :class="imageClass"
      :alt="alt"
      :src="src"
    >
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsImage',
  props: {
    /**
     * Alternate text for screen readers. Leave empty for decorative images.
     *
     */
    alt: String,
    /**
     * Changes `object-fit` to `contain`. The default is `cover`.
     *
     */
    contain: {
      type: Boolean,
      default: false,
    },
    /**
     * Makes the image rounded.
     *
     */
    rounded: {
      type: Boolean,
      default: false,
    },
    /**
     * Adds a subtle border to images
     *
     */
    bordered: {
      type: Boolean,
      default: false,
    },
    /**
     * Sets the width for the component.
     *
     */
    width: [Number, String],
    /**
     * Sets the height for the component.
     *
     */
    height: [Number, String],
    /**
     * The image URL.
     *
     */
    src: {
      type: String,
      required: true,
    },
    /**
     * Image styles yo
     */
    imageStyles: {
      type: String,
      default: '',
    },

    imageClass: {
      type: String,
      default: '',
    },
    /**
     * Specify a custom tag used on the root element.
     */
    tag: {
      type: String,
      default: 'div',
    },
  },
  computed: {
    imageClasses(): Record<string, boolean> {
      return {
        'rs-image__image--contain': this.contain,
        'rs-image--rounded': this.rounded,
        'rs-image--bordered': this.bordered,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.rs-image {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
  &--bordered {
    border: $card-border;
  }
  &__image {
    position: relative;
    height: auto;
    max-width: 100%;
    object-fit: cover;
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
    }
    &--contain {
      object-fit: contain;
    }
  }
  &--rounded {
    border-radius: $global-radius;
    & > img {
      border-radius: 0;
    }
  }
}
</style>
